import { merge } from 'lodash';
import Alert from './Alert';
import Autocomplete from './Autocomplete';
import Badge from './Badge';
import Button from './Button';
import CardContent from './CardContent';
import Checkbox from './Checkbox';
import CssBaseline from './CssBaseline';
import FormControlLabel from './FormControlLabel';
import Radio from './Radio';
import Switch from './Switch';
import IconButton from './IconButton';
import InputLabel from './InputLabel';
import LinearProgress from './LinearProgress';
import Link from './Link';
import ListItemIcon from './ListItemIcon';
import Menu from './Menu';
import OutlinedInput from './OutlinedInput';
import Paper from './Paper';
import Tab from './Tab';
import TableCell from './TableCell';
import Tabs from './Tabs';
import ToggleButton from './ToggleButton';
import Typography from './Typography';
import { Theme } from '@mui/material/styles';
import MuiDialog from './Dialog';
import Tooltip from './Tooltip';

export default function ComponentsOverrides(theme: Theme) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return merge(
    Alert(theme),
    Autocomplete(theme),
    Button(theme),
    Badge(theme),
    CardContent(),
    Checkbox(theme),
    CssBaseline(),
    FormControlLabel(theme),
    Radio(theme),
    Switch(theme),
    IconButton(theme),
    InputLabel(theme),
    MuiDialog(theme),
    LinearProgress(),
    Link(),
    ListItemIcon(),
    Menu(theme),
    OutlinedInput(theme),
    Paper(),
    Tab(theme),
    TableCell(theme),
    Tabs(),
    ToggleButton(theme),
    Typography(),
    Tooltip(theme),
  );
}
